export default function loader() {
  const requireRouters = require.context("@modules/", true, /^\.\/.*\/router\/index\.js$/);
  const routes = {};

  requireRouters.keys().forEach((fileName) => {
    const requiredModule = requireRouters(fileName);

    Object.keys(requiredModule).forEach((key) => {
      const router = requiredModule[key];
      const routerName = key == "default" ? router.routerName : key;

      if (routes[routerName]) {
        routes[routerName] = [...routes[routerName], ...router.routes];
      } else {
        routes[routerName] = router.routes;
      }
    });
  });

  return routes;
}
